export class CommonTransKey {
  static readonly setting = "common.setting";
  static readonly customer = "common.customer";
  static readonly productAndTechnical = "common.productAndTechnical";
  static readonly order = "common.order";
  static readonly productWarehouse = "common.productWarehouse";
  static readonly paperWarehouse = "common.paperWarehouse";
  static readonly material = "common.material";
  static readonly workOrder = "common.workOrder";
  static readonly receiptOfDelivery = "common.receiptOfDelivery";
  static readonly quotation = "common.quotation";
}
